import pl from "@locales/diet/pl.json";
import en from "@locales/diet/en.json";

export default {
  pl: pl,
  en: en,
};
